import * as z from "zod";

/** Objectives and KRs both carry a mandatory date range so due/overdue alerts and roll-ups can rely on it. */
export const okrDateFields = {
  startDate: z.string().min(1, "Start date is required"),
  dueDate: z.string().min(1, "Due date is required"),
};

// ISO `YYYY-MM-DD` strings compare correctly as text.
export const dueAfterStart = (v: { startDate: string; dueDate: string }, ctx: z.RefinementCtx) => {
  if (v.dueDate < v.startDate) {
    ctx.addIssue({ code: z.ZodIssueCode.custom, path: ["dueDate"], message: "Due date must be on or after the start date" });
  }
};
